(function () {
  'use strict';

  var SERVICE_VARIANT_ID = 52318120706349;
  var TAILORING_FEE_CENTS = 3000;
  var renderTimer = null;
  var renderPromise = null;
  var requirementCache = new Map();

  function money(cents) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' })
      .format(Number(cents || 0) / 100);
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function normaliseBoolean(value) {
    if (value === true) return true;
    if (value === false) return false;
    var text = String(value == null ? '' : value).trim().toLowerCase();
    if (text === 'true' || text === '1' || text === 'yes') return true;
    if (text === 'false' || text === '0' || text === 'no') return false;
    return null;
  }

  async function fetchCart() {
    var response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart could not be loaded.');
    return response.json();
  }

  function getVariantIdFromRow(row) {
    var link = row.querySelector('a.cart-item-link[href]');
    if (!link) return '';
    try {
      return String(new URL(link.href, window.location.origin).searchParams.get('variant') || '');
    } catch (error) {
      return '';
    }
  }

  function pairRowsWithItems(rows, items) {
    var unused = items.map(function (_, index) { return index; });
    return rows.map(function (row, rowIndex) {
      var variantId = getVariantIdFromRow(row);
      var matched = unused.find(function (index) {
        return variantId && String(items[index].variant_id) === variantId;
      });
      if (matched == null) matched = unused.indexOf(rowIndex) !== -1 ? rowIndex : unused[0];
      if (matched == null) return { row: row, item: null };
      unused = unused.filter(function (index) { return index !== matched; });
      return { row: row, item: items[matched] };
    });
  }

  async function requiresTailoring(item) {
    if (!item || Number(item.variant_id) === SERVICE_VARIANT_ID) return false;
    if (item.properties) {
      var privateValue = normaliseBoolean(item.properties._hok_tailoring_required);
      if (privateValue !== null) return privateValue;
      if (String(item.properties.Tailoring || '').toLowerCase().indexOf('+$30') !== -1) return true;
    }
    var variantId = String(item.variant_id || item.id || '');
    if (!variantId) return false;
    if (requirementCache.has(variantId)) return requirementCache.get(variantId);
    try {
      var response = await fetch(item.url || '', {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) return false;
      var html = await response.text();
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var json = parsed.querySelector('.hok-tailoring-json');
      if (!json) return false;
      var map = JSON.parse(json.textContent || '{}');
      var required = map[variantId] === true;
      requirementCache.set(variantId, required);
      return required;
    } catch (error) {
      return false;
    }
  }

  function renderCartBadge(cart) {
    var itemCount = (cart.items || []).reduce(function (total, item) {
      return total + (Number(item.variant_id) === SERVICE_VARIANT_ID ? 0 : Number(item.quantity || 0));
    }, 0);
    document.querySelectorAll('.hok-cart-count-badge').forEach(function (badge) {
      setText(badge, String(itemCount));
      badge.hidden = itemCount < 1;
      badge.setAttribute('aria-label', itemCount + (itemCount === 1 ? ' item in cart' : ' items in cart'));
    });
  }

  function renderSummary(cart) {
    var total = document.querySelector('#cartSlideoutWrapper .js-cart-total');
    var original = document.querySelector('#cartSlideoutWrapper .cart-item-original-total-price .money');
    setText(total, money(cart.total_price));
    if (original) {
      var showOriginal = Number(cart.original_total_price) > Number(cart.total_price);
      setText(original, showOriginal ? money(cart.original_total_price) : '');
      var wrapper = original.closest('.ajax-cart--cart-original-price');
      if (wrapper) wrapper.hidden = !showOriginal;
    }
    var checkoutText = document.querySelector('#cartSlideoutWrapper .cart-button-checkout-text');
    if (checkoutText && !checkoutText.textContent.trim()) setText(checkoutText, 'Checkout');
  }

  async function renderRows(cart) {
    var list = document.querySelector('#cartSlideoutWrapper .cart-items');
    if (!list) return;
    var rows = Array.prototype.slice.call(list.children);
    var pairs = pairRowsWithItems(rows, Array.isArray(cart.items) ? cart.items : []);
    var serviceItem = (cart.items || []).find(function (item) {
      return Number(item.variant_id) === SERVICE_VARIANT_ID;
    });
    var serviceFinalUnit = serviceItem
      ? Number(serviceItem.final_price || serviceItem.price || TAILORING_FEE_CENTS)
      : TAILORING_FEE_CENTS;
    var serviceOriginalUnit = serviceItem
      ? Number(serviceItem.original_price || serviceItem.price || TAILORING_FEE_CENTS)
      : TAILORING_FEE_CENTS;

    for (var i = 0; i < pairs.length; i += 1) {
      var row = pairs[i].row;
      var item = pairs[i].item;
      if (!item) continue;
      if (Number(item.variant_id) === SERVICE_VARIANT_ID) {
        row.hidden = true;
        row.style.display = 'none';
        row.setAttribute('aria-hidden', 'true');
        continue;
      }
      row.hidden = false;
      row.style.display = '';
      row.removeAttribute('aria-hidden');
      var article = row.querySelector('.cart-item') || row;
      var image = article.querySelector('.cart-item-image');
      var imageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (image && imageUrl && image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
      if (image) image.setAttribute('alt', item.product_title || item.title || 'Cart item');
      var oldMeta = article.querySelector('.hok-tailoring-cart-meta');
      var required = await requiresTailoring(item);
      if (!required) {
        if (oldMeta) oldMeta.remove();
        var standardPrice = article.querySelector('.cart-item-price');
        var standardOriginalPrice = article.querySelector('.cart-item-price-original');
        setText(standardPrice, money(Number(item.final_price || item.price || 0)));
        if (standardPrice) standardPrice.removeAttribute('data-hok-includes-tailoring');
        if (standardOriginalPrice) {
          var showStandardOriginal = Number(item.original_price || item.price || 0) > Number(item.final_price || item.price || 0);
          setText(standardOriginalPrice, showStandardOriginal ? money(Number(item.original_price || item.price || 0)) : '');
          standardOriginalPrice.classList.toggle('hide', !showStandardOriginal);
          standardOriginalPrice.hidden = !showStandardOriginal;
        }
        continue;
      }
      var price = article.querySelector('.cart-item-price');
      var originalPrice = article.querySelector('.cart-item-price-original');
      var combinedUnit = Number(item.final_price || item.price || 0) + serviceFinalUnit;
      var combinedOriginalUnit = Number(item.original_price || item.price || 0) + serviceOriginalUnit;
      setText(price, money(combinedUnit));
      if (price) price.setAttribute('data-hok-includes-tailoring', 'true');
      if (originalPrice) {
        var showOriginal = combinedOriginalUnit > combinedUnit;
        setText(originalPrice, showOriginal ? money(combinedOriginalUnit) : '');
        originalPrice.classList.toggle('hide', !showOriginal);
        originalPrice.hidden = !showOriginal;
      }
      if (oldMeta) oldMeta.remove();
    }
  }

  async function render() {
    if (renderPromise) return renderPromise;
    renderPromise = (async function () {
      try {
        var cart = await fetchCart();
        renderCartBadge(cart);
        renderSummary(cart);
        await renderRows(cart);
        renderSummary(cart);
      } catch (error) {
        console.error('HoK cart stability refresh failed.', error);
      } finally {
        renderPromise = null;
      }
    })();
    return renderPromise;
  }

  function schedule(delay) {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(render, delay == null ? 120 : delay);
  }

  function initialise() {
    var drawer = document.querySelector('#cartSlideoutWrapper');
    if (drawer && drawer.dataset.hokCartStabilityV2 !== 'true') {
      drawer.dataset.hokCartStabilityV2 = 'true';
      // Cart redraws must not trigger another redraw. Updates are event-driven.
    }
    schedule(0);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.slide-menu-cart, #cartSlideoutWrapper')) schedule(180);
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.closest('#cartSlideoutWrapper')) schedule(180);
  }, true);
  document.addEventListener('cart:updated', function(){ schedule(100); });
  document.addEventListener('cart:refresh', function(){ schedule(100); });
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
